import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const accessoryItems = [
    { title: 'accessory_notice', type: 'notice' },
    // { title: 'cannot_use_accessory', type: 'use_accessory' },
    // { title: 'how_install_accessory', type: 'install_accessory' },
]

const Accessory = props => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('instruction_book'))
        }
    }

    const handleOnClick = (type) => {
        switch (type) {
            case 'notice':
                navigate('/accessory_faq')
                break;
            case 'use_accessory':
                navigate('/accessory_use')
                break
            case 'install_accessory':
                navigate('/accessory_install')
                break

            default:
                break;
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App" style={{ background: '#F6F7F8' }}>
        {
            accessoryItems.map((item, index) => {
                return <div key={index.toString()} className='instruction-item' onClick={() => {
                    handleOnClick(item.type)
                }}>
                    <span style={styles.itemText}>{t(item.title)}</span>
                    <img src={`${CommonUtil.getSourceDomain()}item_next_img.png`} alt="" style={styles.itemIcon} />
                </div>
            })
        }
    </div>
}

const styles = {
    itemText: {
        marginLeft: 15,
        color: '#000000CC',
        fontSize: 14,
        fontWeight: '500'
    },
    itemIcon: {
        width: 24,
        height: 24,
        marginRight: 15
    },
}

export default Accessory